module.exports = __webpack_public_path__ + "img/2-8.8c3402a3.png";